import { MyInput } from "./styles"

export const Input = (props) => {
    const { type, placeholder, value, onChange } = props
    return (
        <MyInput 
            type={type}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
        />
    )
}